import React, { createContext, useContext, useEffect, useState } from 'react'
import { Table } from 'semantic-ui-react'
import styles from './customer-view.module.css'
import CustomerActions from './customer-info-actions'
import IntelMsg from '../../../ItelMsg'

export const CustomerViewContext = createContext()

const CustomerView = () => {
  const [tableBody, setTableBody] = useState()
  const { setViewCustomer, customerData } = useContext(CustomerViewContext)
  useEffect(() => {
    console.log('customerData: ', customerData)
  }, [])
  useEffect(() => {
    if (customerData) {
      const newTrimmedData = { ...customerData }
      Object.keys(newTrimmedData).map((key) => {
        if (newTrimmedData[key].trim() === '') {
          delete newTrimmedData[key]
        }
        return null
      })
      console.log('customer Data: ', customerData)
      setTableBody(buildRows(newTrimmedData))
    }
  }, [customerData])
  const goBack = () => {
    setViewCustomer(false)
  }
  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="customerDetails" />
      </div>
      <Table definition>
        <Table.Body>{tableBody}</Table.Body>
      </Table>

      <CustomerActions
        onBackClick={() => {
          goBack()
        }}
      />
    </div>
  )
}

const getCustomerRow = (label, value) => (
  <Table.Row>
    <Table.Cell width={3} style={{ textTransform: 'capitalize' }}>
      {label}
    </Table.Cell>
    <Table.Cell>{value}</Table.Cell>
  </Table.Row>
)

const buildRows = (customerData) => {
  const rows = []
  const keys = Object.keys(customerData)
  keys.forEach((key) => {
    if (key === 'sfda-company' || key === 'sfda-common') {
      Object.keys(customerData[key]).forEach((k) => {
        rows.push(
          getCustomerRow(<IntelMsg id={k} />, `${customerData[key][k]}`) ||
            'N/A',
        )
      })
    }
    // console.log(`${key}: ${customerData[key]}`)
    else {
      let text = key
      if (key === 'no of customer facilities') text = 'no of facilities'
      if (key === 'no of customer assets') text = 'no of assets'
      if (key === 'no of customer active devices') text = 'no of active devices'
      rows.push(
        getCustomerRow(
          <IntelMsg id={text.charAt(0).toUpperCase() + text.slice(1)} />,
          `${customerData[key]}`,
        ) || 'N/A',
      )
    }
  })

  return rows
}
export default CustomerView
